import PropTypes from 'prop-types';
import React from 'react';
import S from 'modal.scss';
import StyledSelect from 'components/StyledSelect';
import TextArea from 'components/TextArea';
import { removeFlagFromPhase, clearValidation } from 'actionCreators/phase';
import requestFlagOptions from 'actionCreators/flags';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox';
import { getPhaseErrors, getFlagOptions } from '../../../../../reducers';
import FlagType from 'types/flag';
import { errorSummary, error } from '../../../../../utils';

import styles from 'styles/input.scss';

const DEFAULT_STATE = {
  note: '',
  removalReason: '',
};

class RemoveFlagModal extends React.Component {

  constructor(props) {
    super(props);

    this.handleNoteChange = this.handleNoteChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = DEFAULT_STATE;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.active && !this.props.active) this.props.requestFlagOptions();
  }

  removalReasons() {
    const { flag, flagOptions } = this.props;
    if (!flag) return [];
    const option = (flagOptions || []).find(obj => obj.name === flag.name);
    return (option && option.removal_reasons) || [];
  }

  handleNoteChange(e) {
    this.setState({
      note: e.target.value,
    });
  }

  handleReasonChange(removalReason) {
    this.setState({ removalReason });
  }

  handleSubmit() {
    const { note, removalReason } = this.state;
    const { flag } = this.props;
    const phaseID = flag.phase_id;

    const flagProps = {
      id: flag.id,
      note,
    };
    if (this.removalReasons().length > 0) flagProps.removal_reason = removalReason;

    this.props.removeFlagFromPhase(phaseID, flagProps).then(() => {
      this.handleClose();
    })
     .catch(() => {}); // catching this to avoid console warnings...
  }

  handleClose() {
    const { errors } = this.props;

    if (Object.keys(errors).length === 0) {
      this.props.onClose();
      this.setState(DEFAULT_STATE);
    }
  }

  handleCancel() {
    this.props.clearValidation();
    this.handleClose();
  }

  render() {
    const { note, removalReason } = this.state;
    const { active, flag, errors } = this.props;
    const flagName = flag ? flag.name : '';
    const removalReasons = this.removalReasons();

    return (
      <Dialog
        active={active}
        className={S.modal}
        type="fullscreen"
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
      >

        <div className={styles.errored}>
          {Object.keys(errors).length > 0 &&
            <span className={styles.error}>{errorSummary(errors)}</span>}
        </div>

        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleCancel}
          tabIndex={-1}
        />

        <h5 className={S.title}>Remove Flag - {flagName}</h5>

        {removalReasons.length > 0 && <StyledSelect
          label="Removal Reason"
          options={removalReasons.map(value => ({ value, label: value }))}
          onChange={this.handleReasonChange}
          value={removalReason}
          required
          placeholder="Select a reason"
          error={error('removal_reason', errors)}
        />}

        <TextArea
          label="Notes *"
          value={note}
          errors={errors.note}
          onChange={this.handleNoteChange}
          autoFocus
        />

        <Button
          label="Remove Flag"
          flat inverse ripple
          className={S.submit}
          disabled={removalReasons.length > 0 && !removalReason}
          onClick={this.handleSubmit}
        />
      </Dialog>
    );
  }
}

RemoveFlagModal.propTypes = {
  errors: PropTypes.object,
  active: PropTypes.bool.isRequired,
  removeFlagFromPhase: PropTypes.func.isRequired,
  requestFlagOptions: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  flag: FlagType,
  flagOptions: PropTypes.array,
};

export default connect(
  state => ({
    errors: getPhaseErrors(state),
    flagOptions: getFlagOptions(state),
  }),
  { removeFlagFromPhase, clearValidation, requestFlagOptions },
)(RemoveFlagModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/components/removeFlagModal.jsx